<mat-toolbar color="accent">
	<mat-toolbar-row>
		<span>Details</span>
		<span class="spacer"></span>
		<ng-container *ngIf="hasButtonBack">
			<button mat-raised-button type="button" aria-label="Back" (click)="handleBack()">
				<mat-icon>chevron_left</mat-icon>
			</button>
		</ng-container>
		<ng-container *ngIf="hasButtonEdit">
			<button mat-raised-button type="button" aria-label="Edit" (click)="handleEdit()">
				<mat-icon>edit</mat-icon>
			</button>
		</ng-container>
		<ng-container *ngIf="hasButtonComplete">
			<button mat-raised-button type="button" aria-label="Complete" (click)="handleComplete()">
				<mat-icon>assignment_turned_in</mat-icon>
			</button>
		</ng-container>
	</mat-toolbar-row>
</mat-toolbar>

<div class="field-container" *ngIf="patient">

	<div *ngIf="displayFields.patient_id" class="field-item field-full field-sm-half field-lg-quarter">
		<label>Patient ID</label>
		<span>{{patient.patient_id}}</span>
	</div>

	<div class="field-item field-full field-sm-half field-lg-quarter">
		<label>Hospital</label>
		<span>{{patient.hospital.name}}</span>
	</div>

	<div class="field-item field-full field-sm-half field-lg-quarter">
		<label>Baby's Birth Date</label>
		<span>{{patient.dob | date}}</span>
	</div>

	<div class="field-item field-full field-sm-half field-lg-quarter">
		<label>Baby's Sex</label>
		<span>{{patient.sex}}</span>
	</div>

	<div *ngIf="displayFields.baby_first" class="field-item field-full field-sm-half field-lg-quarter">
		<label>Baby's First</label>
		<span>{{patient.baby_first}}</span>
	</div>

	<div *ngIf="displayFields.baby_last" class="field-item field-full field-sm-half field-lg-quarter">
		<label>Baby's Last</label>
		<span>{{patient.baby_last}}</span>
	</div>

	<div *ngIf="displayFields.mother_first" class="field-item field-full field-sm-half field-lg-quarter">
		<label>Mother's First</label>
		<span>{{patient.mother_first}}</span>
	</div>

	<div *ngIf="displayFields.mother_last" class="field-item field-full field-sm-half field-lg-quarter">
		<label>Mother's Last</label>
		<span>{{patient.mother_last}}</span>
	</div>

	<div class="field-item field-full field-sm-half field-lg-quarter">
		<label>Status</label>
		<span>{{patient.current_status_name}}</span>
	</div>

	<div class="field-item field-full field-sm-half field-lg-quarter">
		<label>Status Date</label>
		<span>{{patient.current_status_date | date:'short' }}</span>
	</div>


	<div *ngIf="displayFields.insurance" class="field-item field-full field-sm-half">
		<label>Insurance</label>
		<span>{{patient.insurance}}</span>
	</div>

	<div *ngIf="displayFields.guarantor" class="field-item field-full field-sm-half">
		<label>Guarantor</label>
		<span>{{patient.guarantor}}</span>
	</div>
	
	<div *ngIf="displayFields.has_ffp_visit" class="field-item field-full field-sm-half field-lg-quarter">
		<label>Household Seen At FFP?</label>
		<span>{{ ( patient.has_ffp_visit ? 'Yes' : 'No' ) }}</span>
	</div>

	<div *ngIf="displayFields.has_future_ffp_visit" class="field-item field-full field-sm-half field-lg-quarter">
		<label>Patient To Be Seen At FFP?</label>
		<span>{{ ( patient.has_future_ffp_visit ? 'Yes' : 'No' ) }}</span>
	</div>

	<div class="field-item field-full">
		<label>CPT Codes (All Visits Aggregated)</label>
		<span>
			<mat-chip-list>
				<mat-chip *ngFor="let chip of previousVisitCptCodes; trackBy: trackByChip" selected [color]="cptColor" matTooltip="{{ chip.description }}" (click)="openSnackBar(chip.description)">
					{{ chip.code }}
				</mat-chip>
			</mat-chip-list>
		</span>
	</div>

	<div class="field-item field-full">
		<label>ICD-10 Codes (All Visits Aggregated)</label>
		<span>
			<mat-chip-list>
				<mat-chip *ngFor="let chip of previousVisitIcdCodes; trackBy: trackByChip" selected [color]="icdColor" matTooltip="{{ chip.description }}" (click)="openSnackBar(chip.description)">
					{{ chip.code }}
				</mat-chip>
			</mat-chip-list>
		</span>
	</div>

	<div class="field-item field-full">
		<label>Notes From All Visits (Aggregated)</label>
		<span>{{ allVisitNotes }}</span>
	</div>
</div>
